import { jsx as _jsx } from "react/jsx-runtime";
import Button from '@jetbrains/ring-ui/components/button/button';
import addIcon from '@jetbrains/icons/add';
import classNames from 'classnames';
import styles from './rule-editor.css';
function AddRuleButton({ onAddRule, className, text = 'Add new rule' }) {
    return (_jsx(Button, { primary: true, icon: addIcon, onClick: () => onAddRule(), className: classNames(styles.addRuleButton, className), children: text }));
}
export default AddRuleButton;
